import api from './api';
import types from './mutation-types';
import _ from 'lodash';

export default {
	/**commit mutations*/
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setPopupInit_({ commit }) {
		commit(types.POPUP_INIT);
	},
	setFindPopupInit_({ commit }) {
		commit(types.FIND_POPUP_INIT);
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setPopupSearchParams_({ commit }, { key, value }) {
		commit(types.POPUP_SEARCH_PARAMS, { key, value });
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setFindPopupSearchParams_({ commit }, { key, value }) {
		commit(types.FIND_POPUP_SEARCH_PARAMS, { key, value });
	},
	setFindPopupPagingInfo_({ commit }, { key, value }) {
		commit(types.FIND_POPUP_PAGING_INFO, { key, value });
	},
	setDetailForm_({ commit }, payload) {
		commit(types.DETAIL_FORM, payload);
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	/**call API */
	async setAltrLgrpList_({ state, dispatch }) {
		const { altrTypeCd } = state.detailForm;
		const key = 'altrLgrpList';
		await dispatch('getCommCodes_', { key, codeType: altrTypeCd });
	},
	async setAltrSgrpList_({ state, dispatch }) {
		const { altrPrvsLgrpCd } = state.detailForm;
		const key = 'altrSgrpList';
		await dispatch('getCommCodes_', { key, codeType: altrPrvsLgrpCd });
	},
	/**한번에 공통 코드 부르기 */
	async getCommCodesOnce_({ commit }) {
		try {
			function sortCommCdList(commCd, val) {
				const key = _.camelCase(commCd) + 'CdList';
				const list = [];
				val.length && val.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				commit(types.DEFAULT_ASSIGN, { key, value: list });
			}
			const { header, body } = await api.getCommCodesOnce();
			if (header.code === 0) {
				for (const [key, val] of Object.entries(body)) {
					sortCommCdList(key, val);
				}
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async setIsirCsetScn_({ state, commit }, { codeType, commCd }) {
		try {
			const { header, body } = await api.getCommCodeDetails({ codeType, commCd });
			if (header.code === 0) {
				if (body.resultList.length) {
					commit(types.DETAIL_FORM, { key: 'isirCsetScnCd', value: body.resultList[0].cdDesc });
				} else {
					commit(types.DETAIL_FORM, { key: 'isirCsetScnCd', value: '20' });
				}
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async getCommCodes_({ commit, rootState }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType, rootState['commonStore'].user.plantCd);
			if (header.code === 0) {
				const list = [];
				body.length && body.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				await commit(types.DEFAULT_ASSIGN, { key, value: list });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async getList_({ commit, state }, findPopup) {
		try {
			if (findPopup) {
				//eo4m 찾기 팝업으로 검색했을 경우
				const { findPopupSearchParams, findPopupPagingInfo } = state;
				const { header, body } = await api.getList({
					searchParams: findPopupSearchParams,
					currentPage: findPopupPagingInfo.currentPage,
					pageUnit: findPopupPagingInfo.pageUnit
				});
				if (header.code === 0) {
					const { pagingInfo, resultList } = body;
					commit(types.DEFAULT_ASSIGN, { key: 'findPopupPagingInfo', value: pagingInfo });
					commit(types.DEFAULT_ASSIGN, { key: 'findPopupResultList', value: resultList });
				} else if (header.code === 3) {
				}
				return header;
			} else {
				const { searchParams, pagingInfo } = state;
				const { header, body } = await api.getList({ searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit });
				if (header.code === 0) {
					const { pagingInfo, resultList } = body;
					commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
					commit(types.DEFAULT_ASSIGN, { key: 'resultList', value: resultList });
				} else if (header.code === 3) {
				}
				return header;
			}
		} catch (error) {
			throw error.header || error;
		}
	},
	async getOne_({ commit }, { partNo, altrNo }) {
		try {
			const {
				header,
				body: { resultList, affrList }
			} = await api.getOne({ partNo, altrNo });
			if (header.code === 0) {
				const value = { ...resultList };
				commit(types.DEFAULT_ASSIGN, { key: 'detailForm', value });
				commit(types.DEFAULT_ASSIGN, { key: 'rmkHistory', value: affrList });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async getSearchOne_({ commit, state }) {
		try {
			let {
				popupSearchParams: { partNo, altrNo }
			} = state;
			const {
				header,
				body: { resultList, affrList }
			} = await api.getOne({ partNo, altrNo });
			if (header.code === 0) {
				const value = { ...resultList };
				commit(types.DEFAULT_ASSIGN, { key: 'detailForm', value });
				commit(types.DEFAULT_ASSIGN, { key: 'rmkHistory', value: affrList });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async saveData_(store, data) {
		try {
			const response = await api.saveData(data);
			return response;
		} catch (error) {
			throw error.header || error;
		}
	},
	async updateData1_(store, data) {
		try {
			const response = await api.updateData1(data);
			return response;
		} catch (error) {
			throw error.header || error;
		}
	},
	async updateData_({ state }, param) {
		try {
			const { header } = await api.updateData(param);
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async deleteData_({ state }, param) {
		try {
			const { header } = await api.deleteData(param);
			return header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async fileDownload_(store, params = { fileId, fileSeq }) {
		try {
			const response = await api.fileDownload(params);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			throw error.header || error;
		}
	},
	async imgDownload_(store, params = { fileId, fileSeq }) {
		try {
			const response = await api.fileDownload(params);
			const filename = decodeURIComponent(response.headers.filename);
			const filetype = decodeURIComponent(filename.substring(filename.lastIndexOf('.') + 1));
			let url = '';
			if ('|JPG|PNG|GIF|'.indexOf(filetype.toUpperCase()) > -1)
				url = window.URL.createObjectURL(new Blob([response.data], { type: 'image/png' }));
			return { name: filename, url };
		} catch (error) {
			throw error.header || error;
		}
	}
};
